module.exports = __webpack_public_path__ + "static/media/Latinghei-Demibold.fb6d0936.ttf";